import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface TipoDeAatendimentoProps {
  tipoDeAtendimento: number;
}

export function useMotivosAtendimento(
  props: QueryGlobalInterface & TipoDeAatendimentoProps
) {
  const fetchData = async () => {
    const MOTIVOS_ATENDIMENTOS = `${leadsWebEnviroment}/app-web/atendimentos/motivos/v1?tipoDeAtendimento=${props?.tipoDeAtendimento}`;
    const response = await instance.get(MOTIVOS_ATENDIMENTOS);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    cacheTime: 0,
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar motivos. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
